import { lazy, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './index.css';

// Dev model gallery (`?gallery`), loaded only when asked for.
const ModelGallery = lazy(() =>
  import('./components/gallery/ModelGallery').then((m) => ({ default: m.ModelGallery }))
);
const showGallery = new URLSearchParams(window.location.search).has('gallery');

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Missing #root');
}

createRoot(rootElement).render(
  <StrictMode>
    {showGallery ? (
      <Suspense fallback={null}>
        <ModelGallery />
      </Suspense>
    ) : (
      <App />
    )}
  </StrictMode>
);
